import { SET_ORDER_HISTORY } from './constants';

const initialState = {};

export const orderHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ORDER_HISTORY: {
            return { ...state, ...action.payload };
        }
        default: {
            return state;
        }
    }
};
